import { MouseEvent, ReactElement } from "react";
import { Color } from "../../../../utils/sys/Color";
import InventoryItemIconLibrary from "../../../../utils/sys/InventoryItemIconLibrary";
import { MutableRefObject } from "react";

import "./InventoryItemIcon_style.css";

type Props = {
    bgSrc?: string | null;
    iconSrc?: string | null;
    bgColor?: Color | null;
    iconColor?: Color | null;
    onClick?: (e?: MouseEvent) => void;
    className?: string;
    forwardRef?: MutableRefObject<any>;
};

export default function InventoryItemIcon({
    bgSrc,
    iconSrc,
    bgColor,
    iconColor,
    onClick,
    className,
    forwardRef,
}: Props): ReactElement {
    const bg = InventoryItemIconLibrary.image(bgSrc);
    const icon = InventoryItemIconLibrary.image(iconSrc);

    return (
        <div
            ref={forwardRef}
            className={`item-icon-container${
                className != null ? ` ${className}` : ``
            }`}
            onClick={onClick}
        >
            <div className="item-img-stack">
                {bg != null && <img className="item-bg" src={bg} />}
                {bg != null && (
                    <img
                        className="item-bg"
                        src={bg}
                        style={{
                            ...(bgColor != null
                                ? {
                                      filter: `opacity(0.5) drop-shadow(0 0 0 ${bgColor})`,
                                  }
                                : undefined),
                        }}
                    />
                )}

                {icon != null && (
                    <img
                        className="item-icon"
                        src={icon}
                        style={{
                            ...(iconColor != null
                                ? {
                                      filter: `opacity(1)`,
                                  }
                                : undefined),
                        }}
                    />
                )}
                {icon != null && (
                    <img
                        className="item-icon"
                        src={icon}
                        style={{
                            ...(iconColor != null
                                ? {
                                      filter: `opacity(0.5) drop-shadow(0 0 0 ${iconColor})`,
                                  }
                                : undefined),
                        }}
                    />
                )}
            </div>
        </div>
    );
}
